import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';

export const WeaponFirePunch: WeaponDefinition = {
  id: 'firePunch',
  name: 'Fire Punch',
  icon: 'firepnch.1.png',
  category: 'melee',
  maxAmmo: 10,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, world } = ctx;

    const punchRange = 25;
    const punchDamage = 30;
    const uppercut = 350;
    const horizontal = 80;

    const wormCenter = worm.getCenterPosition();
    const punchX =
      worm.facing === 'right' ? wormCenter.x + punchRange / 2 : wormCenter.x - punchRange / 2;
    const punchY = wormCenter.y;

    const hitWorms = [];

    for (const target of world.getWorms()) {
      if (target.id === worm.id) continue;
      if (target.state === 'dead') continue;

      const targetCenter = target.getCenterPosition();
      const dx = targetCenter.x - punchX;
      const dy = targetCenter.y - punchY;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist < punchRange) {
        const pushX = worm.facing === 'right' ? horizontal : -horizontal;
        const pushY = -uppercut;

        target.addPendingDamage(punchDamage);
        target.applyExplosionPush(pushX, pushY);
        hitWorms.push(target);
      }
    }

    const drillRadius = 12;
    const drillHeight = 120;
    for (let dy = 0; dy < drillHeight; dy += drillRadius) {
      world.destroyTerrainCircle(wormCenter.x, wormCenter.y - dy, drillRadius);
    }

    worm.velocity.y = -uppercut * 0.6;
    worm.isGrounded = false;

    return {
      success: true,
      entities: [],
      message: hitWorms.length > 0 ? `Uppercut! Hit ${hitWorms.length}` : 'Whiff!',
      hitWorms,
    };
  },
};
